/*
 * Copyright (c) 2024. Bolmate B.V.
 */
import './style/existingUserSubscription.scss';

import {ChangeKeyFunction, CloseButton, Loader, preventDefault, WithBackground} from '@dvrd/dvr-controls';
import React, {MouseEventHandler} from 'react';
import User, {UserFields} from '../../../models/userModel';
import {PersonalErrors} from "../../settings/common/userErrorsInterface";
import {ErrorResetter} from "../../../util/interfaces";
import {BolmateButton, BolmateInput} from "../../controls";
import CountryField from "../../controls/country/field/countryField";

type Errors = Pick<PersonalErrors, 'address' | 'zipCode' | 'city'>;

interface Props {
    onCancel: MouseEventHandler;
    onSubmit: MouseEventHandler;
    onChange: ChangeKeyFunction<keyof UserFields, any>;
    onResetError: ErrorResetter<Errors>;
    active: boolean;
    user: User;
    loading: boolean;
    errors: Errors;
    hasFullAddress: boolean;
}

export default function ExistingUserSubscription(props: Props) {
    const {user, active, loading, errors, onResetError, onCancel, onSubmit, onChange, hasFullAddress} = props;

    function renderBody() {
        return (
            <div className='body-container'>
                <Loader active={loading}/>
                <p className='message'>
                    Voor het toevoegen van een verkoopaccount heb je een eigen abonnement nodig.<br/>
                    Door verder te gaan starten we een gratis proefperiode van 14 dagen, deze loopt automatisch af.<br/>
                    Alleen als jij het wilt, wordt er daarna een abonnement gestart.<br/>
                    Je kunt de proefperiode te allen tijde stopzetten.
                </p>
                {!hasFullAddress && (
                    <form className='user-data-container' onSubmit={preventDefault}>
                        <p className='data-message'>Voor het starten van de proefperiode hebben we de volgende gegevens
                            nodig:</p>
                        <BolmateInput onChange={onChange('address')} value={user.address} label='Adres'
                                      placeholder='Straatnaam + huisnummer' error={errors.address}
                                      onFocus={onResetError('address')}/>
                        <BolmateInput onChange={onChange('zip_code')} value={user.zipCode} label='Postcode'
                                      placeholder='Postcode' error={errors.zipCode} onFocus={onResetError('zipCode')}/>
                        <CountryField onChange={onChange('country')} value={user.country} itemsPosition='top'
                                      itemsHeight='15rem' labelAsValue/>
                        <BolmateInput onChange={onChange('city')} value={user.city} label='Plaats'
                                      placeholder='Plaats' error={errors.city} onFocus={onResetError('city')}/>
                    </form>
                )}
            </div>
        )
    }

    return (
        <WithBackground active={active} onClose={onCancel} preventBackgroundClick escapeDisabled>
            <div className='default-popup existing-user-subscription'>
                <div className='header-container'>
                    <label className='header-title'>Abonnement vereist</label>
                    <CloseButton onClick={onCancel}/>
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BolmateButton onClick={onCancel} label='Annuleren' disabled={loading} secondary/>
                    <BolmateButton onClick={onSubmit} label='Proefperiode starten' disabled={loading}/>
                </div>
            </div>
        </WithBackground>
    )
}